import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useTable, useGlobalFilter, usePagination, useSortBy, useRowSelect, Column, UseSortByColumnOptions, TableOptions, UseFiltersOptions, CellProps, Cell } from "react-table";
import { Row, Col, Table, Input, Button } from "reactstrap";
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import { CustomStyleColumnAE, getTdTableStylesAE } from 'helpers/Table/tableFunctionsAE';
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import SelectItem from 'components/Varios/select';
import { EstadoRevisionTH, OptionsSelect } from 'Types/GeneralTypes';
import Datepicker from 'components/Varios/Datepicker';
import { classNameCrossCircle, classNameDownload, classNameIconoLupa, classNameIconoUpload } from 'constants/Icons-Font-Awesome';
import Cargando from 'components/Varios/Cargando';
import { GetDocumentVistaPrevia, GetDownloadDocument } from 'helpers/files';
import { authenticationService } from 'services/authentication.service';
import ModalSubirDocumentoFirmado, { ObjetoSubirDocumento } from 'components/Varios/Modals/ModalSubirDocumentoFirmado';
import { PersonalFirmaAvisoEntrada } from './TypesFirmaAvisoEntrada';
import { ObtenerFechaFromIsoFormat } from 'helpers/DateFunctions';
import "../../../assets/scss/Components/Tables/TablaFinancieroAvisoEntrada.scss"
import ModalIngresarObservacion from '../../Varios/Modals/ModalIngresarObservacion';
import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"
import AnularSVG from "assets/icons/Permisos/anularXazul.svg"
import UploadSVG from "assets/icons/Permisos/UploadBlue.svg"


type PropsTablaCertificarCredenciales = {
    loading: boolean,
    informacion: PersonalFirmaAvisoEntrada[],
    onClickSubirDocumentoFirmado: (objeto: ObjetoSubirDocumento) => Promise<void>;
    onClickRechazarDocumentoServidor: (idOtrosDocumentos: number, observacion: string) => Promise<number>;
}

type InfoDocumentoAFirmar = {
    idOtrosDocumentos: number,
    tipoFirma: string | undefined
}

export function ParseTipoFirma(tipoF: string) {
    if (tipoF === "Firma electrónica") {
        return "E"
    }
    else {
        return "F"
    }
}

export default function TablaFirmaPersonalAvisoEntrada(props: PropsTablaCertificarCredenciales) {

    const defaultInfoAFirmar: InfoDocumentoAFirmar = {
        idOtrosDocumentos: -1,
        tipoFirma: undefined
    }

    const [informacion, setinformacion] = useState<PersonalFirmaAvisoEntrada[]>(props.informacion);
    const [docAvisoEntrada, setdocAvisoEntrada] = useState<InfoDocumentoAFirmar>(defaultInfoAFirmar);
    const [docAvisoEntradaNegar, setdocAvisoEntradaNegar] = useState<number>(-1);

    async function HandleClickSubirDocModal(objeto: ObjetoSubirDocumento) {

        await props.onClickSubirDocumentoFirmado(objeto)
        setdocAvisoEntrada(defaultInfoAFirmar);
    }

    useEffect(() => {

        setinformacion(props.informacion);

    }, [props.informacion])

    const CellDescargarElemento = (celda: CellProps<PersonalFirmaAvisoEntrada, string>) => {
        return (
            <div className="containerAvisoEntrada">
            <i
                data-toggle="tootip" data-placement="top" title="Descargar Documento a Firmar"
                onClick={() => GetDownloadDocument(celda.value, authenticationService.currentUserValue.token, "Documento Aviso Entrada")}
            >
                <img
                    src={PdfSVG}
                    className="acciones"
                    alt="Descargar Documento a Firmar"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Descargar Documento a Firmar"
                    style={{ width: 24, height: 24 }}
                />
                </i>
            </div>
        )
    }

    const CellSubirDocumento = (celda: CellProps<PersonalFirmaAvisoEntrada, number>) => {
        return (
            <div className="containerAvisoEntrada">
                <i
                    data-toggle="tootip" data-placement="top" title="Subir Documento Firmado"
                    onClick={() => setdocAvisoEntrada({
                        idOtrosDocumentos: celda.value,
                        tipoFirma: ParseTipoFirma(celda.row.original.tipoFirma.trim())
                    })}
                >
                    <img
                        src={UploadSVG}
                        className="acciones"
                        alt="Subir Documento Firmado"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Subir Documento Firmado"
                        style={{ width: 24, height: 24 }}
                    />
                </i>
            </div>
        )
    }

    const RechazarFirmaServidor = (celda: CellProps<PersonalFirmaAvisoEntrada, number>) => {
        return (
            <div className="containerAvisoEntrada">
                <i
                    data-toggle="tootip" data-placement="top" title="Negar Documento a Servidor"
                    onClick={() => setdocAvisoEntradaNegar(celda.value)}
                >
                    <img
                        src={AnularSVG}
                        className="acciones"
                        alt="Negar Documento a Servidor"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Negar Documento a Servidor"
                        style={{ width: 24, height: 24 }}
                    />
                </i>
            </div>
        )
    }

    const NegarDocumento = async (docAvisoEntradaNegar: number, observacion: string) => {
        const success = await props.onClickRechazarDocumentoServidor(docAvisoEntradaNegar, observacion);
        setdocAvisoEntradaNegar(-1);
        return success
    }

    type typeColumna = Column<PersonalFirmaAvisoEntrada> & UseFiltersOptions<PersonalFirmaAvisoEntrada>

    const columnas = useMemo<readonly typeColumna[]>(() => [
        {
            Header: '#',
            accessor: (originalrow, index) => index + 1,
            disableSortBy: true,
            disableGlobalFilter: true
        },
        {
            Header: "Nombre Completo",
            accessor: "nombres",
        },
        {
            Header: "Tipo firma",
            accessor: "tipoFirma"
        },
        {
            Header: "Fecha Documento",
            accessor: "fechaDocAvisoEntrada",
            Cell: (celda: CellProps<PersonalFirmaAvisoEntrada, Date | undefined>) => {
                var algo = celda.value ? ObtenerFechaFromIsoFormat(celda.value.toString()) : "";
                return <div>{algo}</div>;
            }
        },
        {
            Header: "Descargar Documento sin Firma",
            accessor: "refAvisoEntrada",
            Cell: (celda: CellProps<PersonalFirmaAvisoEntrada, string>) => {
                return CellDescargarElemento(celda)
            }
        },        
        {
            Header: "Subir Documento Firmado",
            accessor: "idOtrosDocumentos",
            Cell: (celda: CellProps<PersonalFirmaAvisoEntrada, number>) => {
                return CellSubirDocumento(celda)
            }
        },
        {
            Header: "Negar Documento Servidor",
            id: "acciones",
            accessor: "idOtrosDocumentos",
            Cell: (celda: CellProps<PersonalFirmaAvisoEntrada, number>) => {
                return RechazarFirmaServidor(celda)
            }
        }

    ], [props.informacion])

    const columnasStyles = (cell: Cell<PersonalFirmaAvisoEntrada>): CustomStyleColumnAE[] => {
        const estilos: CustomStyleColumnAE[] = [
            {
                HeaderName: "#",
                StyleHeader: {
                    textAlign: "center",
                    width: "50px"
                }
            },
            {
                HeaderName: "Nombre Completo",
                StyleHeader: {
                    textAlign: "left",
                    width: "170px"
                }
            }
        ]
        return estilos;
    }

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        setPageSize,
        selectedFlatRows,
        visibleColumns,
        prepareRow,
        setColumnOrder,
        allColumns,
        state,
        setGlobalFilter,
    } = useTable(
        {
            data: informacion,
            columns: columnas,
            autoResetSortBy: false,
            autoResetHiddenColumns: false,
            autoResetGlobalFilter: false,
            initialState: {
                hiddenColumns: ["decripcionoculta"],
                pageSize: 15
            }
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
    )
    const { globalFilter, pageIndex, pageSize } = state;
    const sizerows = informacion.length;
    const alteredpage = page.map((row, indice) => {
        row.values = { ...row.values, "#": indice + 1 }

        return row;
    })

    return (
        <React.Fragment>
            <Row>
                <Col xl={12}>
                    <div className="containerBtnAprobacionesVacLic">
                    <GlobalFilterTable
                        filter={globalFilter}
                        setFilter={setGlobalFilter}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xl={12}>
                    <Table className={"tablesReact"} responsive {...getTableProps()} style={{ border: 'solid 1px ' }} >
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                        >
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>

                            {props.loading && <tr className='text-center'><td colSpan={7}><Cargando /></td></tr>}
                            {!props.loading && alteredpage.map((row, indirow) => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map(cell => {
                                            return getTdTableStylesAE(cell, { border: 'solid 1px black', fontSize: "14px" }, indirow, columnasStyles(cell))
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </Table>
                    {
                        !props.loading &&
                        <ComponentePaginacionTabla
                            page={alteredpage}
                            sizerows={sizerows}
                            canNextPage={canNextPage}
                            canPreviousPage={canPreviousPage}
                            nextPage={nextPage}
                            pageIndex={pageIndex}
                            pageOptions={pageOptions}
                            pageSize={pageSize}
                            previousPage={previousPage}
                            setPageSize={setPageSize}
                        />
                    }
                </Col>
            </Row>
            <Row>
                <ModalSubirDocumentoFirmado
                    show={docAvisoEntrada.idOtrosDocumentos > 0}
                    admiteFirmaFisica={true}
                    cargandoDatos={false}
                    size='md'
                    tituloModal='Subir Documento de Aviso de Entrada Firmado'
                    onClose={() => { setdocAvisoEntrada(defaultInfoAFirmar) }}
                    onClickFirmaFisica={(objeto: ObjetoSubirDocumento) => HandleClickSubirDocModal(objeto)}
                    onClickSubirDocFirmaElectronica={(objeto: ObjetoSubirDocumento) => HandleClickSubirDocModal(objeto)}
                    extraData={{ "tipoDoc": "AE", "idOtrosDocumentos": docAvisoEntrada.idOtrosDocumentos }}
                    soloTipoFirma={docAvisoEntrada.tipoFirma}
                />
            </Row>
            <Row>
                <ModalIngresarObservacion
                    show={docAvisoEntradaNegar > 0}
                    centered={true}
                    size='xl'
                    tituloModal='Notificar al Servidor, novedades en el documento subido'
                    onClose={() => setdocAvisoEntradaNegar(-1)}
                    mensajeHtml={<div></div>}
                    asyncOnClick={async (observacion: string) => await NegarDocumento(docAvisoEntradaNegar, observacion)}
                />
            </Row>
        </React.Fragment>
    )
}